import { COLORS } from '@btime/constants'
import { getExtension } from '@btime/helpers'
import React from 'react'

import { HorizontalLine } from '../../shapes/Line'
import { Text } from '../Text'
import { useGalleryActions, useGalleryState } from './GalleryHandler'
import DocumentThumb from './DocumentThumb'
import FlexGrid, { FlexCol } from '../../structure/FlexGrid'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Link from '../../actions/Link'
import LoadingWrapper from '../../../packages/kiti/components/helpers/LoadingWrapper'
import Modal from '../../structure/Modal'
import SeparatorWrapper from '../../helpers/SeparatorWrapper'
import Media from '../Media'

const ZoomGalleryModal = ({ useRotation = false }) => {
  const { selected, canRemove, loading } = useGalleryState()

  const { onClose, goToNextImage, goToPrevImage, handleTransform } = useGalleryActions()

  const { type, value, label } = selected
  const extension = getExtension(value)

  return (
    <Modal open={!!selected} onClose={onClose} noPadding width="auto">
      <div>
        <FlexGrid>
          {type === 'image' || type === 'video' ? (
            <Media type={type} src={value} maxHeight={'75vh'} />
          ) : (
            <DocumentThumb height="25rem" width="25rem" iconSize="8rem" extension={extension} />
          )}
        </FlexGrid>

        <HorizontalLine thin lineColor={COLORS.light3} />

        <SeparatorWrapper weight={4}>
          <FlexGrid justify="space-between" gutter={1}>
            <Text>{label}</Text>
            <FlexCol maxHeight={55}>
              <FlexGrid justify="space-between" gutter={0.4}>
                {useRotation && type === 'image' && (
                  <>
                    <LoadingWrapper loading={loading} size={1} type="spin">
                      <Link onClick={handleTransform({ rotate: -90 })}>
                        <Icon name="RiArrowGoBackFill" size={0.9} />
                      </Link>

                      <Link onClick={handleTransform({ rotate: 90 })}>
                        <Icon name="RiArrowGoForwardFill" size={0.9} />
                      </Link>
                    </LoadingWrapper>
                  </>
                )}
                <Link href={value} download target="_blank">
                  <Icon name="RiDownloadCloudLine" size={0.9} />
                </Link>
                <Link onClick={goToPrevImage}>
                  <Icon name="RiArrowLeftLine" size={0.9} />
                </Link>
                <Link onClick={goToNextImage}>
                  <Icon name="RiArrowRightLine" size={0.9} />
                </Link>
              </FlexGrid>
            </FlexCol>
          </FlexGrid>
        </SeparatorWrapper>
      </div>
    </Modal>
  )
}

export default ZoomGalleryModal
